<script>
  import { Tooltip } from 'flowbite-svelte';

  export let length = 50;
  export let text = '';
  export let showTooltip = true;
</script>

{#if text.length > length}
  <span>{text.slice(0, length)}...</span>
  {#if showTooltip}
    <Tooltip>{text}</Tooltip>
  {/if}
{:else}
  {text}
{/if}
